import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import editStyles from "../../SchoolBlocks/styles/EditPane.module.scss";
import { RequiredInput } from "../../SchoolBlocks/EditBlockComponents/EditBlockInputs/RequiredInput";
import { useStores } from "../../../../stores/useStores";
import AccordionItemSummaryContentEditor from "./AccordionItemSummaryContentEditor";

const AccordionItemEditor = observer(
  (
    props: {
      blockObj: IAccordionTerrace;
      index: number;
      handleSave: (item: IAccordionItemEditing) => Promise<IAccordionItem>;
      handleCancel: () => void;
    } & (
      | {
          item: IAccordionItem;
          parentItem?: never;
        }
      | {
          item?: never;
          parentItem: IAccordionItem;
        }
      | {
          item?: never;
          parentItem?: never;
        }
    ),
  ) => {
    const { interfaceStore } = useStores();

    const [title, setTitle] = useState(props?.item?.title || "");
    const htmlId = `accordion-item-editor${props.parentItem ? "-" + props.parentItem.id : ""}${props.item ? "-" + props.item.id : ""}-${props.index}`;

    const titleIsValid = title && title?.length > 0;

    const handleTitleChange = (event) => {
      setTitle(event.target.value);
    };

    const handleSave = async (
      item: IAccordionItemEditing,
    ): Promise<IAccordionItem> => {
      interfaceStore.scrollToElement(`#${htmlId}`, { behavior: "instant" });
      return await props.handleSave(item);
    };

    useEffect(() => {
      interfaceStore.scrollToElement(`#${htmlId}`);
    }, []);

    return (
      <div id={htmlId}>
        <div className={editStyles.inputGroup}>
          <label>Title</label>
          <div>
            <RequiredInput
              title="Message Title"
              className="form-control"
              type="text"
              onChange={handleTitleChange}
              value={title}
              valid={!!titleIsValid}
            />
          </div>
        </div>
        <AccordionItemSummaryContentEditor
          title={title}
          blockObj={props.blockObj}
          item={props.item}
          index={props.index}
          handleSave={handleSave}
          handleCancel={props.handleCancel}
        />
      </div>
    );
  },
);

export default AccordionItemEditor;
